import { GroupingData, SimpleItem } from '../types/common/modal/Item';

/**
 *  SimpleListModal에 뿌려줄 SimpleItem으로 형변환해주는 함수
 * @param {T} param 변환하려는 원래의 item 객체
 * @param {number} id item의 id(pk)
 * @param {string} name item의 이름)
 * @param {number} price item의 가격
 * @param {string} subText 뵤충 텍스트에 들어갈 문자열
 * @param {string} spareText 보충 텍스트에 들어갈 문자열
 * @param {boolean} disabled 보충 텍스트에 들어갈 문자열
 * @returns 하나의 SimpleItem<T> 객체를 리턴한다.
 *  */
export const transformObjToSimpleItem = <T>({
  param,
  id,
  name,
  price,
  subText,
  spareText,
  disabled,
}: SimpleItem<T>): SimpleItem<T> => {
  return {
    param,
    id,
    name,
    price,
    subText,
    spareText,
    disabled,
  };
};

/**
 *  GroupingDataList에 뿌줄 GroupingData으로 형변환해주는 함수
 * @param {T} param 변환하려는 원래의 item 객체
 * @param {number} id item의 id(pk)
 * @param {string} name item의 이름
 * @param {number | undefined} price item의 가격(default: 0)
 * @param {string} groupName item의 그룹명
 * @param {string} colorCode colorCode
 * @param {string | undefined} colorCode2 colorCode2
 * @param {string | undefined} colorCode3 colorCode3
 * @param {string | undefined} consignmentAlert 알림
 * @param {string | undefined} url 이미지 url
 * @param {boolean | undefined} selected 정보에 등록된 아이템 여부(default: false)
 * @param {boolean | undefined} active 클릭해서 현재 메인으로 나오는 활성화 여부(default: false)
 * @returns 하나의 GroupingData<T> 객체를 리턴한다.
 *  */
export const transformObjToGroupingData = <T>({
  param,
  id,
  name,
  price = 0,
  groupName,
  colorCode,
  colorCode2,
  colorCode3,
  consignmentAlert,
  url,
  selected = false,
  active = false,
}: GroupingData<T>): GroupingData<T> => {
  return {
    param,
    id,
    name,
    price,
    groupName,
    colorCode,
    colorCode2,
    colorCode3,
    consignmentAlert,
    url,
    selected,
    active,
  };
};
